import React from "react";
import { Row, Col, Input, Table, Label, FormGroup, Card } from "reactstrap";
import { connect } from "react-redux";
import JirangoButton from "../../../../components/UI/Buttons/JirangoButton";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import JirangoLink from "../../../../components/UI/Buttons/JirangoLink";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ListItem, ListItemAvatar, Typography, List } from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import ChatPlaceHolder from "../../placeholders/ChatPlaceholder";
import { ExhibitorPlaceholder } from "../../placeholders/ExhibitorPlaceholder";

function DemoChart(c) {
  const { colors } = c;
  const options = {
    chart: {
      backgroundColor: "transparent",
      plotBorderWidth: null,
      plotShadow: false,
      plotBackgroundColor: "transparent",
      type: "column",
    },
    title: {
      text: "Monthly Average Rainfall",
    },
    xAxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Rainfall (mm)",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Tokyo",
        color: colors.color1,
        data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
      },
      {
        name: "New York",
        color: colors.color2,
        data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5, 106.6, 92.3],
      },
      {
        name: "London",
        color: colors.color3,
        data: [48.9, 38.8, 39.3, 41.4, 47.0, 48.3, 59.0, 59.6, 52.4, 65.2, 59.3, 51.2],
      },
      {
        name: "Berlin",
        color: colors.color4,
        data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1],
      },
      {
        name: "Stockholm",
        color: colors.color5,
        data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1],
      },
    ],
  };
  return (
    <React.Fragment>
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </React.Fragment>
  );
}

const navigationGroupPlaceholder = (template) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              {" "}
              <code>{"<a>"}</code>
            </Label>
            <br />
            <JirangoLink style={{ ...template.content.a, cursor: "pointer", fontSize: template.content.text.fontSize }}>
              {" "}
              <SystemLabel name="ThisIsALinkEng" />
            </JirangoLink>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              {" "}
              <code>{"<button>"}</code>
            </Label>
            <br />
            <JirangoButton style={template.content.button}>Default button</JirangoButton>{" "}
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const inputGroupPlaceholder = (template) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <Label>
                {" "}
                <SystemLabel name="InputField" /> {"  "} <code>{"<input>"}</code>
              </Label>
              <br />
            </Label>
            <FormGroup>
              <Input autoComplete="jirango-nofill" defaultValue="Nam sed congue sapien" id="exampleInput" style={{ ...template.content.input, width: "250px" }} />
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <Label>
                {" "}
                <SystemLabel name="WhenInputIsReadOnly" /> {"  "} <code>{"<input readonly>"}</code>
              </Label>
              <br />
            </Label>
            <FormGroup>
              <Input
                autoComplete="jirango-nofill"
                defaultValue="Readonly field"
                id=""
                readOnly
                style={{ ...template.content.input, width: "250px", opacity: template.content.input.readOnlyOpacity }}
              />
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <Label>
                {" "}
                <SystemLabel name="TextArea" /> {"  "} <code>{'<input type="textarea">'}</code>
              </Label>
              <br />
            </Label>
            <FormGroup>
              <Input
                type="textarea"
                autoComplete="jirango-nofill"
                defaultValue="Readonly field"
                id=""
                readOnly
                style={{ ...template.content.input, minHeight: template.content.input.textAreaMinHeight, width: "250px" }}
              />
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const textGroupPlaceholder = (template) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <code>{"<h1>"}</code>
            </Label>
            <h1 style={template.content.title}>Default Title</h1>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <code>{"<label>"}</code>
            </Label>
            <FormGroup>
              <label style={template.content.label}>Default Label</label>
              <Input />
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <code>{"<h2>"}</code>
            </Label>
            <h4 style={template.content.subtitle}>Default subtitle</h4>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label>
              <code>{"<p>"}</code>
            </Label>
            <p style={template.content.text}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus non nulla nec nibh porttitor aliquam non nec ex. Aliquam erat volutpat. Aenean nec faucibus nisi. Quisque at arcu ac
              neque lobortis commodo. Morbi sodales tincidunt ultricies. Sed finibus felis sit amet tortor tristique sodales. Nulla sed ornare massa. Mauris nibh neque, laoreet at mauris sollicitudin,
              bibendum dictum tellus.
            </p>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  );
};
const connectionPlaceholder = (template) => {
  const obj = template.content.interaction.connections;
  const content = { background: obj.background, borderRadius: obj.borderRadius, borderWidth: obj.borderWidth, borderColor: obj.borderColor };
  const text = { fontFamily: obj.fontFamily, fontWeight: obj.fontWeight, fontSize: obj.fontSize, color: obj.color };
  return (
    <Row>
      <Col>
        <Card
          style={{
            ...content,
            padding: "0px",
            margin: 0,
            width: 300,
            borderColor: content.borderWidth != "unset" && content.borderWidth != "unset" ? content.borderColor : "transparent",
            /*  width: '100%', */
            height: "100%",
          }}
        >
          <ListItem style={{ width: "100%", height: "100%", maxWidth: 250 }}>
            <ListItemAvatar>
              <PeopleIcon style={{ color: text.color }} />
            </ListItemAvatar>
            <div style={{ display: "flex", paddingRight: 22 }}>
              <Typography variant="h6" style={template ? { ...text, marginRight: 10 } : { marginRight: 10 }}>
                77
              </Typography>
              <Typography variant="p" style={template ? text : undefined}>
                <SystemLabel name="Connections" />
              </Typography>
            </div>
          </ListItem>
        </Card>
      </Col>
    </Row>
  );
};

const agendaPlaceholder = (template) => {
  const obj = template.content.interaction.agenda;
  const content = obj.content;
  const title = obj.title;
  const row = obj.row;

  return (
    <Card
      style={{
        height: "100%",
        ...content,
      }}
    >
      <div style={{ ...title, marginBottom: 12 }}>
        <SystemLabel name="AgendaTitle" />
      </div>
      <List
        className="jir-scroll"
        dense={true}
        style={{
          position: "relative",
          overflowY: "auto",
          paddingBottom: "40px",
          overflowX: "hidden",
          /*          backgroundColor: template ? template.content.backgroundColor : undefined, */
        }}
      >
        <React.Fragment>
          <Card style={{ ...row.default.frame, margin: 0 }}>
            <Row>
              <Col>
                <div style={row.default.title}>Agenda 1</div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={row.default.text}>I normalt läge</div>
              </Col>
            </Row>
          </Card>
        </React.Fragment>
        <React.Fragment>
          <Card style={{ ...row.active.frame, margin: 0 }}>
            <Row>
              <Col>
                <div style={row.active.title}>Agenda 2</div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={row.active.text}>I aktivt läge</div>
              </Col>
            </Row>
          </Card>
        </React.Fragment>
        <React.Fragment>
          <Card style={{ ...row.passed.frame, margin: 0 }}>
            <Row>
              <Col>
                <div style={row.passed.title}>Agenda 3</div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={row.passed.text}>I passerat läge</div>
              </Col>
            </Row>
          </Card>
        </React.Fragment>
      </List>
    </Card>
  );
};
class PlaceholderContent extends React.Component {
  render() {
    const { template } = this.props;
    if (template === undefined) return null;
    return (
      <React.Fragment>
        {textGroupPlaceholder(template)}
        <hr />
        {navigationGroupPlaceholder(template)}
        <hr />
        <Row>
          <Col>
            <FormGroup>
              <Label>
                <code>{"<table>, <td>, <th>"}</code>
              </Label>
              <Table>
                <thead>
                  <tr>
                    <th style={template.content.thead}> Company</th>
                    <th style={template.content.thead}>Contact</th>
                    <th style={template.content.thead}>Country</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={template.content.tcell}>Alfreds Futterkiste</td>
                    <td style={template.content.tcell}>Maria Anders</td>
                    <td style={template.content.tcell}>Germany</td>
                  </tr>
                  <tr>
                    <td style={template.content.tcell}>Centro comercial Moctezuma</td>
                    <td style={template.content.tcell}>Francisco Chang</td>
                    <td style={template.content.tcell}>Mexico</td>
                  </tr>
                  <tr>
                    <td style={template.content.tcell}>Ernst Handel</td>
                    <td style={template.content.tcell}>Roland Mendel</td>
                    <td style={template.content.tcell}>Austria</td>
                  </tr>
                  <tr>
                    <td style={template.content.tcell}>Island Trading</td>
                    <td style={template.content.tcell}>Helen Bennett</td>
                    <td style={template.content.tcell}>UK</td>
                  </tr>
                  <tr>
                    <td style={template.content.tcell}>Laughing Bacchus Winecellars</td>
                    <td style={template.content.tcell}>Yoshi Tannamuri</td>
                    <td style={template.content.tcell}>Canada</td>
                  </tr>
                  <tr>
                    <td style={template.content.tcell}>Magazzini Alimentari Riuniti</td>
                    <td style={template.content.tcell}>Giovanni Rovelli</td>
                    <td style={template.content.tcell}>Italy</td>
                  </tr>
                </tbody>
              </Table>
            </FormGroup>
          </Col>
        </Row>
        <hr />
        {inputGroupPlaceholder(template)}
        <Row>
          <Col>
            <DemoChart colors={template.content.chart.colors} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    template: state.template.template,
  };
}
export default connect(mapStateToProps)(PlaceholderContent);
